module.exports = __webpack_public_path__ + "img/logo.57b70c4.png";